module.exports = __webpack_public_path__ + "static/img/13.5a482d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/eng/13.png
// module id = V0Ug
// module chunks = 0